var map = {
	"./en/home": [
		2482,
		482
	],
	"./en/home.json": [
		2482,
		482
	],
	"./en/room": [
		1674,
		674
	],
	"./en/room.json": [
		1674,
		674
	],
	"./zh-CN/home": [
		5520,
		520
	],
	"./zh-CN/home.json": [
		5520,
		520
	],
	"./zh-CN/room": [
		837,
		837
	],
	"./zh-CN/room.json": [
		837,
		837
	],
	"./zh-TW/home": [
		4044,
		44
	],
	"./zh-TW/home.json": [
		4044,
		44
	],
	"./zh-TW/room": [
		8861,
		861
	],
	"./zh-TW/room.json": [
		8861,
		861
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 242;
module.exports = webpackAsyncContext;